import { clear } from '../../../../helpers/compact';
import { CommonSliceType } from '../../../../types/slice';
import { toTextFromProp } from '../../fields/text';

export const deprecatedHighlightedSlice = ({ primary }) =>
  clear({
    type: CommonSliceType.HIGHLIGHTED,
    quote: toTextFromProp('highlighted', primary),
  });

export const highlightedSlice = ({ primary }) =>
  clear({
    type: CommonSliceType.HIGHLIGHTED,
    quote: toTextFromProp('catchphrase', primary),
  });
